module.exports = __webpack_public_path__ + "img/uparrow.3d97ad8e.svg";